import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import dieCategoryService from "../services/die-category.service";
import { setMessage } from "./message";
export const fetchDieCategoryList = createAsyncThunk(
    'diecategory/fetchDieCategoryList',
    async ({ page, pagesize, search, ordering }, thunkAPI) => {
        try {
            const response = await dieCategoryService.getCategoryList(page, pagesize, search, ordering);
            return response.data; // Assuming response contains { data: { users, totalpage, etc. }}
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);
export const fetchDieCategoryListDropdown = createAsyncThunk(
    'diecategory/fetchDieCategoryListDropdown',
    async ({ page, pagesize, search, ordering }, thunkAPI) => {
        try {
            const response = await dieCategoryService.getDieCategoryList(page, pagesize, search, ordering);
            return response.data; // Assuming response contains { data: { users, totalpage, etc. }}
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);
export const fetchArchivedDieCategoryList = createAsyncThunk(
    'dieGroup/fetchArchivedDieCategoryList',
    async ({ page, pagesize, search, ordering }, thunkAPI) => {
        try {
            const response = await dieCategoryService.getDieArchiveCategoryList(page, pagesize, search, ordering);
            return response.data; // Assuming response contains { data, count, totalPages, etc. }
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);
export const createDieCategory = createAsyncThunk(
    'diecategory/createDieCategory',
    async (categoryData, thunkAPI) => {
        try {
            const response = await dieCategoryService.createCategory(categoryData);
            return response.data; // Assuming response contains the created category data
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    }
);
export const editDieCategory = createAsyncThunk(
    'diecategory/editDieCategory',
    async ({ categoryId, categoryData }, thunkAPI) => {
        try {
            const response = await dieCategoryService.editDieCategory(categoryId, categoryData);
            return response.data; // Ensure this returns the updated category data
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const deleteDieCategory = createAsyncThunk(
    'diecategory/deleteDieCategory',
    async (id, thunkAPI) => {
        try {
            await dieCategoryService.deleteDieCategory(id); // Ensure `id` is used here
            return id; // Return the ID of the deleted group
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const unArchiveDieCategory = createAsyncThunk(
    'dieGroup/unArchiveDieCategory',
    async (id, thunkAPI) => {
        try {
            await dieCategoryService.unArchiveDieCategory(id); // Ensure `id` is used here
            return id; // Return the ID of the deleted group
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);

export const resetDieCategoryListThunk = () => (dispatch) => {
    return new Promise((resolve) => {
        dispatch(resetDieCategoryList()); // Dispatch the synchronous action
        resolve(); // Resolve the promise
    });
};

const initialState = {
    data: [],
    list: [],
    loading: false,
    totalpage: 0,
    currentpage: 1,
    totalRecord: 0,
    status: 'idle',
    error: null,
    hasMore: true,
};

const dieCategorySlice = createSlice({
    name: 'dieCategory',
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        resetDieCategoryList: (state) => {
            state.list = []; // This will clear the list
        },
        resetCurrentCategoryPage: (state) => {
            state.currentpage = 1;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchDieCategoryList.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchDieCategoryList.fulfilled, (state, action) => {
                state.status = 'succeeded';
                const fetchedPage = action.payload.page || state.currentpage;
                state.data = action.payload.results.data || [];  // Update to match your API response
                state.totalRecord = action.payload.count || 0; // Handle count (total records)
                state.totalPages = action.payload.totalPages || 0; // Handle totalPages
                state.totaldie = action?.payload?.results?.total_die_count || 0;
                state.currentpage = action.payload.next ? fetchedPage + 1 : fetchedPage;
                state.list = [...action.payload.results.data];
                state.hasMore = !!action.payload.next;
            })
            .addCase(fetchDieCategoryList.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.error.message;
            });
        builder
            .addCase(fetchDieCategoryListDropdown.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchDieCategoryListDropdown.fulfilled, (state, action) => {
                state.status = 'succeeded';
                const fetchedPage = action.payload.page || state.currentpage;
                state.data = action.payload.results.data || [];  // Update to match your API response
                state.totalRecord = action.payload.count || 0; // Handle count (total records)
                state.totalPages = action.payload.totalPages || 0; // Handle totalPages
                state.currentpage = action.payload.next ? fetchedPage + 1 : fetchedPage;
                state.list = [...state.list, ...action.payload.results.data];
                state.hasMore = !!action.payload.next;
            })
            .addCase(fetchDieCategoryListDropdown.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.error.message;
            });

        builder
            .addCase(fetchArchivedDieCategoryList.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchArchivedDieCategoryList.fulfilled, (state, action) => {
                state.status = 'succeeded';
                const fetchedPage = action.payload.page || state.currentpage;
                state.data = action.payload.results.data || [];  // Update to match your API response
                state.totalRecord = action.payload.count || 0; // Handle count (total records)
                state.totalPages = action.payload.totalPages || 0; // Handle totalPages
                state.currentpage = action.payload.next ? fetchedPage + 1 : fetchedPage;
                state.list = [...state.list, ...action.payload.results.data];
                state.hasMore = !!action.payload.next;
            })
            .addCase(fetchArchivedDieCategoryList.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.error.message;
            });
        builder
            .addCase(createDieCategory.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(createDieCategory.fulfilled, (state, action) => {
                state.status = 'succeeded';
            })
            .addCase(createDieCategory.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            });
        builder
            .addCase(editDieCategory.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(editDieCategory.fulfilled, (state, action) => {
                state.status = 'succeeded';
                const index = state.data.findIndex(category => category.id === action.payload.id);
                if (index !== -1) {
                    state.data[index] = action.payload;  // Replace the old category with the updated one
                }
            })
            .addCase(editDieCategory.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            });
        builder
            .addCase(deleteDieCategory.pending, state => {
                state.status = 'loading';
            })
            .addCase(deleteDieCategory.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = state.data.filter(group => group.id !== action.payload); // Remove the deleted group from state
                state.list = state.list.filter(group => group.id !== action.payload); // Remove the deleted group from list
            })
            .addCase(deleteDieCategory.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.error.message;
            });
        builder
            .addCase(unArchiveDieCategory.pending, state => {
                state.status = 'loading';
            })
            .addCase(unArchiveDieCategory.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = state.data.filter(group => group.id !== action.payload); // Remove the deleted group from state
            })
            .addCase(unArchiveDieCategory.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export const { resetDieCategoryList, resetCurrentCategoryPage } = dieCategorySlice.actions;
const { reducer } = dieCategorySlice;
export default reducer;
